import { DeviceManifest } from '@rapoo/device-sdk'
import {
  inputReportV700,
  itineraryDisabled,
  keyFeaturesConfigOnly,
  keyboardMacro,
  keyboardPerfV700,
  retailKeyboardConfig,
} from './generate/capabilityPresets'
import { v700diy98Keys } from './generate/keysGenerate'
import {
  V700IndicatorEffects,
  v700KeyboardEffects,
  V700SideLightingEffects,
} from './generate/lightingPresets'

/**
 * V700diy-98 设备清单
 **/
const rapooV700diy98: DeviceManifest = {
  channel: ['china_game', 'global'],
  model: 'V700diy-98',
  mainControl: 'V700diy-98',
  dongleModel: 'Dongle_Telink',
  type: 'keyboard',
  version: '1.0.0',
  hardware: {
    vendorId: 0x24ae,
    productId: [0x4805, 0x1905],
    currentPid: 0x4805,
    transport: 'HID',
    filters: [
      {
        usagePage: 0xff00,
        usage: 14,
        description: 'VT700 Telink 控制接口',
        type: 'default',
      },
      {
        usagePage: 0xffef,
        usage: 0,
        description: 'VT700 Telink 固件升级接口',
        type: 'update',
      },
    ],
  },
  driver: 'TelinkKeyboard',
  MCU: 'Telink',
  ui: {
    assetsDir: 'manifests/V700diy-98',
    // 颜色配置
    colors: {
      series: [
        {
          name: 'common.products.V700diy_98.White_Gray_Blue',
          value: '#145EFF',
          key: 'White_Gray_Blue',
        },
        {
          name: 'common.products.V700diy_98.Black_Gray_Green',
          value: '#CAF176',
          key: 'Black_Gray_Green',
        },
        {
          name: 'common.products.V700diy_98.Blue_Gray_Pink',
          value: '#FFD1F1',
          key: 'Blue_Gray_Pink',
        },
      ],
      current: 'White_Gray_Blue',
    },
    // 小图标
    icon: 'Hardware-Wireframe-Keyboard',
    // 是否支持设备概览
    overview: true,
  },
  capabilities: [
    retailKeyboardConfig,
    {
      type: 'lighting',
      config: {
        enable: true,
        backlightSwitch: true,
        effects: [...v700KeyboardEffects, ...V700SideLightingEffects, ...V700IndicatorEffects],
      },
    },
    itineraryDisabled,
    keyFeaturesConfigOnly,
    keyboardPerfV700,
    {
      type: 'keys',
      config: v700diy98Keys,
    },
    inputReportV700,
    keyboardMacro,
  ],
  layout: {
    image: 'frame',
    top: 20,
    bottom: 16,
    left: 16,
    right: 16,
    unit: 40,
    keys: [
      [
        {
          key: 0,
          keywords: 'Esc',
          y: 0.2,
        },
        {
          key: 1,
          keywords: 'F1',
          y: 0.2,
          x: 0.25,
        },
        {
          key: 2,
          keywords: 'F2',
          y: 0.2,
        },
        {
          key: 3,
          keywords: 'F3',
          y: 0.2,
        },
        {
          key: 4,
          keywords: 'F4',
          y: 0.2,
        },
        {
          key: 5,
          keywords: 'F5',
          y: 0.2,
          x: 0.25,
        },
        {
          key: 6,
          keywords: 'F6',
          y: 0.2,
        },
        {
          key: 7,
          keywords: 'F7',
          y: 0.2,
        },
        {
          key: 8,
          keywords: 'F8',
          y: 0.2,
        },
        {
          key: 9,
          keywords: 'F9',
          y: 0.2,
          x: 0.25,
        },
        {
          key: 10,
          keywords: 'F10',
          y: 0.2,
        },
        {
          key: 11,
          keywords: 'F11',
          y: 0.2,
        },
        {
          key: 12,
          keywords: 'F12',
          y: 0.2,
        },
        {
          key: 80,
          keywords: 'Delete',
          y: 0.2,
          x: 2.75,
        },
        {
          key: 79,
          keywords: 'PgUp',
          y: 0.2,
        },
        {
          key: 102,
          keywords: 'PgDn',
          y: 0.2,
        },
      ],
      [
        {
          key: 22,
          keywords: '~_`',
          y: 0.3,
        },
        {
          key: 23,
          keywords: '!_1',
          y: 0.3,
        },
        {
          key: 24,
          keywords: '@_2',
          y: 0.3,
        },
        {
          key: 25,
          keywords: '#_3',
          y: 0.3,
        },
        {
          key: 26,
          keywords: '$_4',
          y: 0.3,
        },
        {
          key: 27,
          keywords: '%_5',
          y: 0.3,
        },
        {
          key: 28,
          keywords: '^_6',
          y: 0.3,
        },
        {
          key: 29,
          keywords: '&_7',
          y: 0.3,
        },
        {
          key: 30,
          keywords: '*_8',
          y: 0.3,
        },
        {
          key: 31,
          keywords: '(_9',
          y: 0.3,
        },
        {
          key: 32,
          keywords: ')_0',
          y: 0.3,
        },
        {
          key: 33,
          keywords: '__-',
          y: 0.3,
        },
        {
          key: 34,
          keywords: '+_=',
          y: 0.3,
        },
        {
          key: 35,
          keywords: 'BackSpace',
          y: 0.3,
          w: 2,
        },
        {
          key: 15,
          keywords: 'NumLock',
          y: 0.3,
          x: 0.5,
        },
        {
          key: 37,
          keywords: '/',
          y: 0.3,
        },
        {
          key: 59,
          keywords: '*',
          y: 0.3,
        },
        {
          key: 81,
          keywords: '-',
          y: 0.3,
        },
      ],
      [
        {
          key: 44,
          keywords: 'Tab',
          y: 0.3,
          w: 1.5,
        },
        {
          key: 45,
          keywords: 'Q',
          y: 0.3,
        },
        {
          key: 46,
          keywords: 'W',
          y: 0.3,
        },
        {
          key: 47,
          keywords: 'E',
          y: 0.3,
        },
        {
          key: 48,
          keywords: 'R',
          y: 0.3,
        },
        {
          key: 49,
          keywords: 'T',
          y: 0.3,
        },
        {
          key: 50,
          keywords: 'Y',
          y: 0.3,
        },
        {
          key: 51,
          keywords: 'U',
          y: 0.3,
        },
        {
          key: 52,
          keywords: 'I',
          y: 0.3,
        },
        {
          key: 53,
          keywords: 'O',
          y: 0.3,
        },
        {
          key: 54,
          keywords: 'P',
          y: 0.3,
        },
        {
          key: 55,
          keywords: '{_[',
          y: 0.3,
        },
        {
          key: 56,
          keywords: '}_]',
          y: 0.3,
        },
        {
          key: 57,
          keywords: '|_\\',
          y: 0.3,
          w: 1.5,
        },
        {
          key: 103,
          keywords: '7_Home',
          y: 0.3,
          x: 0.5,
        },
        {
          key: 125,
          keywords: '8_↑',
          y: 0.3,
        },
        {
          key: 16,
          keywords: '9_PgUp',
          y: 0.3,
        },
        {
          key: 104,
          keywords: '+',
          y: 0.3,
          h: 2,
        },
      ],
      [
        {
          key: 66,
          keywords: 'CapsLock',
          y: 0.3,
          w: 1.75,
        },
        {
          key: 67,
          keywords: 'A',
          y: 0.3,
        },
        {
          key: 68,
          keywords: 'S',
          y: 0.3,
        },
        {
          key: 69,
          keywords: 'D',
          y: 0.3,
        },
        {
          key: 70,
          keywords: 'F',
          y: 0.3,
        },
        {
          key: 71,
          keywords: 'G',
          y: 0.3,
        },
        {
          key: 72,
          keywords: 'H',
          y: 0.3,
        },
        {
          key: 73,
          keywords: 'J',
          y: 0.3,
        },
        {
          key: 74,
          keywords: 'K',
          y: 0.3,
        },
        {
          key: 75,
          keywords: 'L',
          y: 0.3,
        },
        {
          key: 76,
          keywords: ':_;',
          y: 0.3,
        },
        {
          key: 77,
          keywords: '"_\'',
          y: 0.3,
        },
        {
          key: 78,
          keywords: 'Enter',
          y: 0.3,
          w: 2.25,
        },
        {
          key: 38,
          keywords: '4_←',
          y: 0.3,
          x: 0.5,
        },
        {
          key: 60,
          keywords: '5',
          y: 0.3,
        },
        {
          key: 82,
          keywords: '6_→',
          y: 0.3,
        },
      ],
      [
        {
          key: 88,
          keywords: 'Shift_L',
          y: 0.3,
          w: 2.25,
        },
        {
          key: 90,
          keywords: 'Z',
          y: 0.3,
        },
        {
          key: 91,
          keywords: 'X',
          y: 0.3,
        },
        {
          key: 92,
          keywords: 'C',
          y: 0.3,
        },
        {
          key: 93,
          keywords: 'V',
          y: 0.3,
        },
        {
          key: 94,
          keywords: 'B',
          y: 0.3,
        },
        {
          key: 95,
          keywords: 'N',
          y: 0.3,
        },
        {
          key: 96,
          keywords: 'M',
          y: 0.3,
        },
        {
          key: 97,
          keywords: '<_,',
          y: 0.3,
        },
        {
          key: 98,
          keywords: '>_.',
          y: 0.3,
        },
        {
          key: 99,
          keywords: '?_/',
          y: 0.3,
        },
        {
          key: 100,
          keywords: 'Shift_R',
          y: 0.3,
          w: 1.75,
        },
        {
          key: 101,
          keywords: '↑',
          y: 0.5,
          x: 0.25,
        },
        {
          key: 126,
          keywords: '1_End',
          y: 0.3,
          x: 0.25,
        },
        {
          key: 17,
          keywords: '2_↓',
          y: 0.3,
        },
        {
          key: 39,
          keywords: '3_PgDn',
          y: 0.3,
        },
        {
          key: 117,
          keywords: 'NumEnter',
          y: 0.3,
          h: 2,
        },
      ],
      [
        {
          key: 110,
          keywords: 'Ctrl_L',
          y: 0.3,
          w: 1.25,
        },
        {
          key: 111,
          keywords: 'Win_L',
          y: 0.3,
          w: 1.25,
        },
        {
          key: 112,
          keywords: 'Alt_L',
          y: 0.3,
          w: 1.25,
        },
        {
          key: 113,
          keywords: 'Space_L',
          y: 0.3,
          w: 6.25,
        },
        {
          key: 118,
          keywords: 'Alt_R',
          y: 0.3,
        },
        {
          key: 119,
          keywords: 'Fn',
          y: 0.3,
        },
        {
          key: 121,
          keywords: 'Ctrl_R',
          y: 0.3,
        },
        {
          key: 122,
          keywords: '←',
          y: 0.5,
          x: 0.25,
        },
        {
          key: 123,
          keywords: '↓',
          y: 0.5,
        },
        {
          key: 124,
          keywords: '→',
          y: 0.5,
        },
        {
          key: 61,
          keywords: '0_Ins',
          y: 0.3,
          x: 0.25,
        },
        {
          key: 116,
          keywords: '._Del',
          y: 0.3,
        },
      ],
    ],
  },
}

export default rapooV700diy98
